export const EmbedRoutes = [
  { path: 'calendar', lazy: () => import('./pages/embed.$oid.calendar'), },
  { path: 'festivals/:pid/calendar', lazy: () => import('./pages/embed.$oid.festivals.$pid.calendar'), },
  // Internal-only: the two-phone composite filmed for the check-in screencast.
  { path: 'screencast-checkin', lazy: () => import('./pages/embed.screencast-checkin'), },
]
